import React from 'react';
import { Box, Typography, Link as MuiLink, Container } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Logo from '../../components/common/Logo';

const NAV_LINKS = [
  { to: '/confidentialite', label: 'Confidentialité' },
  { to: '/conditions', label: 'Conditions' },
  { to: '/suppression-compte', label: 'Suppression de compte' },
  { to: '/contact', label: 'Contact' },
];

function LegalLayout({ title, children }) {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#FFF7E5', color: '#333' }}>
      <Box
        component="header"
        sx={{
          bgcolor: '#fff',
          borderBottom: '1px solid #e8ddd4',
          px: 2,
          py: 1.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          flexWrap: 'wrap',
        }}
      >
        <Box component={RouterLink} to="/" sx={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
          <Logo />
        </Box>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: { xs: 1.5, sm: 2.5 } }}>
          {NAV_LINKS.map((item) => (
            <MuiLink
              key={item.to}
              component={RouterLink}
              to={item.to}
              underline="hover"
              sx={{ color: '#784e3c', fontWeight: 600, fontSize: { xs: '0.8rem', sm: '0.9rem' } }}
            >
              {item.label}
            </MuiLink>
          ))}
        </Box>
      </Box>

      <Container maxWidth="md" sx={{ py: { xs: 4, sm: 6 } }}>
        <Typography
          component="h1"
          sx={{
            fontFamily: 'Achiko, sans-serif',
            color: '#784e3c',
            fontSize: { xs: '1.75rem', sm: '2.25rem' },
            fontWeight: 700,
            mb: 3,
          }}
        >
          {title}
        </Typography>
        <Box
          sx={{
            bgcolor: '#fff',
            borderRadius: 2,
            p: { xs: 2.5, sm: 4 },
            boxShadow: '0 2px 12px rgba(120, 78, 60, 0.06)',
            '& h2': {
              color: '#784e3c',
              fontSize: '1.15rem',
              fontWeight: 700,
              mt: 3,
              mb: 1.5,
            },
            '& p, & li': {
              lineHeight: 1.7,
              color: '#444',
              mb: 1.25,
            },
            '& ul': {
              pl: 2.5,
              mb: 2,
            },
            '& a:not(.MuiButton-root)': {
              color: '#784e3c',
              fontWeight: 600,
            },
            '& .MuiButton-root': {
              color: 'inherit',
            },
            '& a.MuiButton-contained': {
              color: '#fff !important',
            },
          }}
        >
          {children}
        </Box>

        <Typography variant="body2" sx={{ mt: 3, color: '#777', textAlign: 'center' }}>
          baoubab by bokonzi —{' '}
          <MuiLink href="mailto:bokonzibaoubab@gmail.com" sx={{ color: '#784e3c' }}>
            bokonzibaoubab@gmail.com
          </MuiLink>
        </Typography>
      </Container>
    </Box>
  );
}

export default LegalLayout;
